import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ThinkingStep } from '@Models';

interface UseThinkingDisplayParams {
  steps: ThinkingStep[];
  startedAtMs: number | null;
  /** Agent language (e.g. "ES"); falls back to "en" like the rest of the turn. */
  lng?: string;
}

interface ThinkingDisplay {
  elapsedSeconds: number;
  label: string;
}

/** Live label (the model's latest note) and elapsed timer for the in-progress thinking panel. */
const useThinkingDisplay = ({ steps, startedAtMs, lng }: UseThinkingDisplayParams): ThinkingDisplay => {
  const { t } = useTranslation();
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    if (startedAtMs === null) return undefined;
    const tick = () => setElapsedSeconds(Math.max(0, Math.floor((Date.now() - startedAtMs) / 1000)));
    tick();
    const id = window.setInterval(tick, 250);
    return () => window.clearInterval(id);
  }, [startedAtMs]);

  const current = steps.length > 0 ? steps[steps.length - 1] : null;
  if (current) return { elapsedSeconds, label: current.label };
  return { elapsedSeconds, label: t('Agent.ThinkingInitial', { lng: (lng || 'en').toLowerCase() }) };
};

export default useThinkingDisplay;
